<template lang="pug">
  div
    table.table.table-striped.table-bordered
      tr
        td Название исследования
        td {{formatAnswer(data.title, 2)}}
      tr(v-if="data.body.content.method")
        td Описание метода
        td {{formatAnswer(data.body.content.method, 2)}}
      tr
        td Дата забора биоматериала
        td
          span(v-if="data.body.content.sampling_date!==undefined") {{data.body.content.sampling_date | date}}
          span(v-if="data.body.content.sampling_date===undefined") —
      tr
        td Дата выполнения исследования
        td
          span(v-if="data.completion_date!==undefined") {{data.completion_date | date}}
          span(v-if="data.completion_date===undefined") —
      tr
        td Группа лабораторного исследования
        td {{formatAnswer(data.body.content.fsli_group_text, 2)}}
      tr
        td Результаты исследования
        td
          div(v-if="data.body.content.results && data.body.content.results.length > 0" )
            table.table.table-striped.table-bordered
              thead
                tr
                  th Параметр
                  th Код ФСЛИ
                  th Значение
                  th Единицы измерения
                  th Референтные значения
              tr(v-for='result in data.body.content.results')

                td {{formatAnswer(result.parameter_name, 2)}}
                td {{formatAnswer(result.parameter_code, 2)}}
                td {{formatAnswer(result.parameter_value, 2)}}
                td {{formatAnswer(result.measurement_unit, 2)}}
                td(v-if='result.lower_limit || result.upper_limit') {{result.lower_limit}} — {{result.upper_limit}}
                td(v-if='!result.lower_limit && !result.upper_limit') —
          div(v-if="!data.body.content.results || data.body.content.results.length < 1") —
      tr
        td Комментарий лаборатории
        td(v-if="data.body.content.comments") {{data.body.content.comments}}
        td(v-if="!data.body.content.comments") —
          //- tr
          //-   td Описание
          //-   td
          //-     div(v-if="data.body.content.description") {{data.body.content.description}}
          //-     div(v-if="!data.body.content.description") —
</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type) {
      switch (type) {
        case 1:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
